import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04e2cdd5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/doctor.css?vue&type=style&index=0&id=04e2cdd5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2cdd5",
  null
  
)

export default component.exports